export const locale = {
  lang: 'en',
  full: {
    SUPPORT: `Support`,
    CONTACT: 'Contact us',
    WHY: 'Why us?'
  }
};
